<script>
import { required, minLength } from "vuelidate/lib/validators";
import { euroCouponsCouponMethods } from "@state/helpers";
export default {
  name: "ConfirmRedemption",

  props: {
    closeModal: {
      type: Function,
      default: () => {},
    },
    form: {
      type: Object,
      required: true,
    },
    //   onSubmit: {
    //     type: Function,
    //     required: true,
    //   },
    //   submitting: {
    //     type: Boolean,
    //     default: false
    //   },
    //   warningMessage:{
    //   type: String,
    //   required: false,
    //   default: null
    // }
  },

  data() {
    return {
      showModal: true,
      submitting: false,
      showSuccess: false,
      showError: false,
      showLoading: false,
    };
  },
  validations: {
    form: {
      customer: {
        required,
        minLength: minLength(7),
      },
    },
  },
  methods: {
    ...euroCouponsCouponMethods,
    submit() {
      let context = this;
      context.submitting = true;
      context.$v.form.$touch();
      if (context.$v.form.$invalid) {
        context.submitting = false;
        context.$generate_toast(context, "error", context.$t("fill_the_required_fields"));
        return;
      }
      context.showLoading = true;
      context.copyClipboard(context.form.customer);
      if (context.form.value) {
        context.form.value = parseInt(context.form.value);
      }
      const promise = context.RedeemEuroCouponsCoupon(context.form);
      return promise
        .then((data) => {
          // context.$generate_toast(
          //   context,
          //   'success',
          //   `${context.$t('coupon')} ${context.$t('redeemed')} ${context.$t(
          //     'correctly'
          //   )}`
          // )
          context.showLoading = false;
          context.showSuccess = true;
          setTimeout(() => {
            context.showSuccess = false;
            context.submitting = false;
            this.$emit("set_state", data.state);
            this.$emit("set_redemption_date", data.redemption_date);

            this.$emit("set_value", Number(data.value));
            // copyClipboard(value)
            this.closeModal();
          }, 2000);
        })
        .catch((error) => {
          context.showLoading = false;
          context.showError = true;
          setTimeout(() => {
            context.showError = false;
            context.submitting = false;
          }, 4000);
          // context.$axios_error_noty(error, context)
        });
    },
    copyClipboard(value) {
      setTimeout(() => {
        navigator.clipboard.writeText(value);
      }, 500);
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      centered
      v-model="showModal"
      hide-header
      hide-footer
      :return-focus="'#coupon-input'"
      @hide="closeModal"
    >
      <div class="m-3">
        <b-row>
          <!-- <sweetalert-icon
                icon="success"
              /> -->
          <!-- <sweetalert-icon
                icon="info"
              /> -->
          <!-- <sweetalert-icon

                icon="loading"
              /> -->
          <div v-if="showSuccess" class="w-100 text-center">
            <sweetalert-icon icon="success" />
            <h4>Bono redimido correctamente.</h4>
          </div>
          <div v-if="showError" class="w-100 text-center">
            <sweetalert-icon icon="error" />
            <h4>Error al redimir, intente de nuevo.</h4>
          </div>
          <div v-if="showLoading" class="w-100 text-center">
            <sweetalert-icon icon="loading" />
            <h4>Redimiendo...</h4>
          </div>
        </b-row>
        <b-row v-if="!submitting">
          <div class="d-flex flex-column justify-content-center text-center mb-2 w-100">
            <span style="font-size: 20px">
              ¿Está seguro que desea redimir el bono?
              <br />
              Indique el documento del cliente para finalizar.
            </span>
          </div>
          <div class="w-100">
            <b-form id="form">
              <form-wrapper :validator="$v.form">
                <b-col md="12">
                  <!-- <pre>{{ form }}</pre> -->

                  <form-group
                    name="customer"
                    :label="$t(`document`)"
                    :description="$t(`document`)"
                  >
                    <b-form-input
                      class="border-primary"
                      v-model="form.customer"
                      type="number"
                      @input="
                        (value) => {
                          $emit('set_customer', Number(value));
                          // copyClipboard(value)
                        }
                      "
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                </b-col>
              </form-wrapper>
            </b-form>
          </div>
        </b-row>
        <!-- <div class="h4 text-primary font-weight-bold">Atención</div> -->
        <!-- <div v-if="warningMessage">{{ warningMessage }}</div> -->

        <!-- <slot></slot> -->
      </div>

      <b-row v-if="!submitting">
        <b-col class="p-3">
          <b-button-group class="w-100">
            <b-button
              variant="outline-primary"
              :disabled="submitting"
              @click="closeModal"
              size="lg"
              class="rounded-lg mr-2"
              >{{ $t("cancel") }}</b-button
            >
            <b-button
              variant="primary"
              :disabled="submitting"
              @click="submit"
              size="lg"
              class="rounded-lg"
            >
              <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
              <span v-if="submitting"> {{ $t("saving") }} </span>
              <span v-else>
                <i class="fe-save"></i>
                {{ $t("confirm") }}
              </span>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
